// JavaScript для content
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для content
});
